import React from 'react';
import PdxNavPanelSection from '../PdxNavPanel/PdxNavPanelSection';
import PdxNavPanelSectionArticle from '../PdxNavPanel/PdxNavPanelSectionArticle';
import PdxNavPanelSectionHeader from '../PdxNavPanel/PdxNavPanelSectionHeader';

const WhatsNewPanel = () => (
  <PdxNavPanelSection split gray>
    <PdxNavPanelSectionHeader>
      Learn More
    </PdxNavPanelSectionHeader>
    <PdxNavPanelSectionArticle
      title="My On-Call Shifts"
      link="https://support.pagerduty.com/docs/my-on-call-shifts"
      description="View shifts across all escalation policies and schedules in a single view"
    />
    <PdxNavPanelSectionArticle
      title="Intelligent Recommendations"
      link="https://www.pagerduty.com/early-access"
      description="Reduce event noise and improve team health. Sign up for early access."
    />
  </PdxNavPanelSection>
);

export default WhatsNewPanel;
